import { render, staticRenderFns } from "./ResultsListBusinessItemItem.vue?vue&type=template&id=4c02c14e"
import script from "./ResultsListBusinessItemItem.vue?vue&type=script&lang=js"
export * from "./ResultsListBusinessItemItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports